import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppState } from '../shared/models/models';

export const getAppState = createFeatureSelector<AppState>('app');

export const getRationComponents = createSelector(
  getAppState,
  (state: AppState) => state.rationComponents,
);
